import { connect } from 'react-redux';
import RootStoreContext from '~/contexts/RootStoreContext';
import * as selectors from '~/domains/customization/selectors';
import { selectors as featureFlagsSelectors } from '~/domains/featureFlags';
import { HERO_IMAGE_CONTAIN_MODE_ENABLED } from '~/domains/featureFlags/keys';
import WelcomeSection from './WelcomeSection';

const mapStateToProps = (state, { isEditMode }) => {
  const heroImage = selectors.heroImage(state, { isEditMode });
  const title = selectors.welcomeTitle(state, { isEditMode });
  const text = selectors.welcomeText(state, { isEditMode });
  const textColor = selectors.textColor(state, { isEditMode });
  const isHeroContainMode = featureFlagsSelectors.featureFlag(
    state,
    HERO_IMAGE_CONTAIN_MODE_ENABLED
  );

  return {
    isEditMode,
    heroImage,
    title,
    text,
    textColor,
    isHeroContainMode
  };
};

export default connect(mapStateToProps, null, null, {
  context: RootStoreContext
})(WelcomeSection);
